import { render, staticRenderFns } from "./CarPageAd.vue?vue&type=template&id=694f7008&scoped=true"
import script from "./CarPageAd.vue?vue&type=script&lang=js"
export * from "./CarPageAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694f7008",
  null
  
)

export default component.exports